import store from '@/store'
import Base from '../components/ModuleBase'
import Dashboard from '../views/Dashboard'

const routes = [
  {
    path: '/tasks/',
    component: Base,
    meta: { appKey: 'tasks' },
    children: [
      {
        path: 'dashboard',
        component: Dashboard,
        name: 'TasksDashboard',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      }
    ]
  }
]

export default routes
